import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChipBaseComponent } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
  },
})
export class ChipWebComponent extends ChipBaseComponent {
  @Input() selected = false;
}
